'use client';

import React from 'react';
import Link from 'next/link';
import { ISSUES } from '@/lib/mockData';
import StatusBadge from '@/components/ui/StatusBadge';

// Backend integration point: replace with /api/issues?status=open
export default function OpenIssuesTable() {
  const openIssues = ISSUES?.filter((i) => i?.status !== 'Closed')?.slice(0, 6);

  const severityCounts = {
    Critical: ISSUES?.filter((i) => i?.severity === 'Critical' && i?.status !== 'Closed')?.length,
    High: ISSUES?.filter((i) => i?.severity === 'High' && i?.status !== 'Closed')?.length,
    Moderate: ISSUES?.filter((i) => i?.severity === 'Moderate' && i?.status !== 'Closed')?.length,
    Low: ISSUES?.filter((i) => i?.severity === 'Low' && i?.status !== 'Closed')?.length,
  };

  return (
    <div className="card overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-4 py-3 border-b border-[hsl(var(--border))] flex-shrink-0">
        <div>
          <h2 className="text-sm font-semibold text-[hsl(var(--text-primary))]">Open Issues</h2>
          <p className="text-xs text-[hsl(var(--text-muted))] mt-0.5">{openIssues?.length} active</p>
        </div>
        <Link href="/vendor-management" className="btn-ghost text-xs">View All</Link>
      </div>
      {/* Severity summary */}
      <div className="grid grid-cols-4 divide-x divide-[hsl(var(--border))] border-b border-[hsl(var(--border))] flex-shrink-0">
        {Object.entries(severityCounts)?.map(([sev, count]) => (
          <div key={`sev-${sev}`} className="px-3 py-2 text-center">
            <p className="text-lg font-bold tabular-nums text-[hsl(var(--text-primary))]">{count}</p>
            <p className="text-2xs text-[hsl(var(--text-muted))] mt-0.5">{sev}</p>
          </div>
        ))}
      </div>
      {/* Issues list */}
      <div className="flex-1 overflow-y-auto divide-y divide-[hsl(var(--border))]">
        {openIssues?.map((issue) => (
          <div key={issue?.id} className="px-4 py-2.5 hover:bg-[hsl(var(--background))] transition-colors">
            <div className="flex items-start justify-between gap-2 mb-1">
              <span className="text-2xs font-mono text-[hsl(var(--text-muted))]">{issue?.id}</span>
              <div className="flex items-center gap-1 flex-shrink-0">
                <StatusBadge type="severity" value={issue?.severity} />
              </div>
            </div>
            <p className="text-xs font-medium text-[hsl(var(--text-primary))] leading-snug mb-1">
              {issue?.description?.length > 60 ? issue?.description?.slice(0, 60) + '…' : issue?.description}
            </p>
            <div className="flex items-center justify-between">
              <span className="text-2xs text-[hsl(var(--text-muted))] truncate">{issue?.vendorName}</span>
              <StatusBadge type="issue-status" value={issue?.status} className="flex-shrink-0" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}